import i18n from '../../plugins/i18n';

const state = {
  loading: false,
};

const mutations = {
  loading(state, value) {
    state.loading = value;
  },
};

const actions = {
  DELETE({ commit, getters, rootGetters }, {
    confirm, id, getter, entity, word = 'name', component, key, action, module, notification, callback
  }) {
    // Get the qty of elements or single element
    const quantity = (Array.isArray(id)) ? id.length : 1;
    // Get the number or id of element(s) to delete
    const expectedValue = (!Array.isArray(id))
      ? i18n.tc(`entities.${entity}`, quantity)
      : (
        (id.length < 2)
          ? i18n.tc(`entities.${entity}`, quantity)
          : id.length
      );
    // Get list of records
    const { data } = rootGetters[getter];
    // Get the value with the function use
    const valueToWork = (!Array.isArray(id))
      ? id
      : (
        (id.length < 2)
          ? id[0] : id
      );
    // Save the obj found
    const get = data.find(x => x.id === valueToWork);
    // Get the element to compare
    const compare = (!Array.isArray(id))
      ? get[key]
      : (
        (id.length < 2)
          ? get[key]
          : id.length.toString()
      );
    // Function for add or remove disabled attribute to delete button
    const disabled = (e) => {
      // Get only the value
      const { value } = e.target;
      // Set the query element
      const el = '.delete-modal .ant-btn-danger';
      // Remove disabled if is equal
      if (compare.toLowerCase() === value.toLowerCase()) document.querySelector(el).removeAttribute('disabled');
      // Add if it's different
      else document.querySelector(el).setAttribute('disabled', '');
    };

    confirm({
      class: 'delete-modal',
      title: i18n.tc('words.deleting.sure', quantity, { entity: i18n.tc(`entities.${entity}`, quantity) }),
      content: h => h(component, {
        props: {
          value: (!Array.isArray(id))
            ? get[key]
            : (
              (id.length < 2) ? get[key] : ''
            ),
          locale1: i18n.t('words.deleting.undone'),
          locale2: i18n.tc('words.deleting.permanently', quantity, { entity: i18n.tc(`entities.${entity}`, quantity) }),
          locale3: i18n.t('words.deleting.all'),
          confirmText: i18n.tc('words.deleting.type', quantity, { entity: expectedValue, word: i18n.t(`words.${word}`).toLowerCase() }),
          warning: i18n.t('words.deleting.caution'),
          change: disabled,
        },
      }),
      okText: i18n.t('words.remove', { entity: i18n.tc(`entities.${entity}`, quantity) }),
      okButtonProps: {
        props: { disabled: true, loading: getters.loading },
      },
      centered: true,
      okType: 'danger',
      cancelText: i18n.t('words.cancel'),
      onOk() {
        return new Promise((resolve, reject) => {
          commit('loading', true);
          action(`${module}/${ (Array.isArray(id)) ? 'deletes' : 'delete' }`, id)
            .then(() => {
              notification.success({
                message: i18n.tc('words.deleted.success.title', quantity, { entity: i18n.tc(`entities.${entity}`, quantity) }),
                description: i18n.tc('words.deleted.success.description', quantity, { entity: i18n.tc(`entities.${entity}`, quantity), name: compare }),
              });
              resolve(commit('loading', false));
              callback();
            }).catch((e) => {
              notification.error({
                message: i18n.tc('words.deleted.fail.title', quantity, { entity: i18n.tc(`entities.${entity}`, quantity) }),
                description: i18n.tc('words.deleted.fail.description', quantity, { entity: i18n.tc(`entities.${entity}`, quantity), name: compare }),
              });
              console.log(e);
              reject(commit('loading', false));
            });
        }).catch(console.log);
      },
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
